"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

var _ServiceSettings = _interopRequireDefault(require("../../../ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ENERGY_CLASSES = {
  'A+++': 1,
  'A++': 1,
  'A+': 1,
  A: 1,
  B: 1,
  C: 1,
  D: 1,
  E: 1
};
/**
 * This class is used for parsing data recieved from RetailItemComm.
 */

var RetailItemParser = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {ArticleServiceConfig} config Service config.
   */
  function RetailItemParser(config) {
    _classCallCheck(this, RetailItemParser);

    this._productInfoPageUrl = config.productInfoPageUrl;
  }
  /**
   * Parses data recieved from RetailItemComm service.
   *
   * @param {object} data Incomming data.
   * @returns {object[]} Parsed items.
   */


  _createClass(RetailItemParser, [{
    key: "parse",
    value: function parse(data) {
      if (data.RetailItemCommList && data.RetailItemCommList.RetailItemComm) {
        if (Array.isArray(data.RetailItemCommList.RetailItemComm)) {
          return this._parseItemsData(data.RetailItemCommList.RetailItemComm);
        } else {
          return this._parseItemsData([data.RetailItemCommList.RetailItemComm]);
        }
      }

      return [];
    }
    /**
     * Parses item data recieved from RetailItemComm service.
     *
     * @param {object[]} items Array of items.
     * @returns {object[]} Parsed items.
     */

  }, {
    key: "_parseItemsData",
    value: function _parseItemsData(items) {
      var _this = this;

      if (items) {
        var itemsData = [];

        var _iterator = _createForOfIteratorHelper(items),
            _step;

        try {
          var _loop = function _loop() {
            var item = _step.value;
            var prices = {};
            var commPrice = item.RetailItemCommPriceList.RetailItemCommPrice;

            var isNew = _this._isNewItem(item);

            var technicalInfo = _this._getTechnicalInformationList(item.RetailItemTechnicalInformationGroupList);

            var energyClass = _this._getEnergyClass(technicalInfo);

            var measurements = _this._getMeasurements(item);

            var packageMeasurements = _this._getPackageMeasurements(item);

            var itemProductInfoPageUrl = void 0; // M2 has no redirect for /spr/S12345678 so we need to remove the S prefix for mobile to support SPR urls in m2.

            if (_this._productInfoPageUrl.includes('{articleType}')) {
              itemProductInfoPageUrl = _this._productInfoPageUrl.replace('{articleID}', item.ItemNo.$).replace('{articleType}', item.ItemType.$.toLowerCase());
            } else {
              if (item.ItemType.$ === 'SPR') {
                itemProductInfoPageUrl = _this._productInfoPageUrl.replace('{articleID}', item.ItemNo.$).replace('{lowerCaseSprPrefix}', 's').replace('{upperCaseSprPrefix}', 'S');
              }

              itemProductInfoPageUrl = _this._productInfoPageUrl.replace('{articleID}', item.ItemNo.$).replace('{lowerCaseSprPrefix}', '').replace('{upperCaseSprPrefix}', '');
            }

            var isFamily = false;
            var isFamilyTemporary = false;
            var isNewLowerPrice = false;
            var isTimeRestrictedOffer = false;

            if (Array.isArray(commPrice)) {
              for (var j = 0, k = commPrice.length; j < k; j++) {
                var priceObj = _this._getPriceObject(commPrice[j]);

                if (priceObj) {
                  if (commPrice[j].RetailPriceType.$ === 'IKEAFamilySalesUnitPrice') {
                    isFamily = true;
                    prices.FamilyPrice = priceObj;

                    if (commPrice[j].ReasonCode && commPrice[j].ReasonCode.$ === 'Temporary') {
                      isFamilyTemporary = true;
                    }
                  } else if (commPrice[j].ReasonCode && commPrice[j].ReasonCode.$ === 'NewLowerPrice') {
                    isNewLowerPrice = true;
                    prices.NormalPrice = priceObj;
                  } else if (commPrice[j].ReasonCode && commPrice[j].ReasonCode.$ === 'TimeRestrictedOffer') {
                    isTimeRestrictedOffer = true;
                    prices.NormalPrice = priceObj;
                  } else {
                    prices.RegularPrice = priceObj;
                  }
                }
              }

              if (!prices.NormalPrice && prices.RegularPrice) {
                prices.NormalPrice = prices.RegularPrice;
              }
            } else {
              prices.NormalPrice = _this._getPriceObject(commPrice);
            }

            var data = {
              ID: String(item.ItemNo.$),
              LocalID: String(item.ItemNo.$),
              GlobalID: String(item.ItemNoGlobal.$),
              ItemType: item.ItemType.$.toUpperCase(),
              ArticleNumber: _this._getArticleNumber(item.ItemNo.$),
              ProductName: item.ProductName.$,
              ProductTypeName: item.ProductTypeName && item.ProductTypeName.$ ? _this._parseHtml(item.ProductTypeName.$) : null,
              ValidDesignText: item.ValidDesignText ? item.ValidDesignText.$ : null,
              Prices: prices,
              PriceUnitText: item.PriceUnitTextMetric ? item.PriceUnitTextMetric.$ : '',
              PriceUnitTextEn: item.PriceUnitTextMetricEn ? item.PriceUnitTextMetricEn.$ : '',
              PriceUnitFactor: item.ItemPriceUnitFactorMetric ? item.ItemPriceUnitFactorMetric.$ : 1,
              isOnlineSellable: item.OnlineSellable.$,
              isBreathTakingItem: item.BreathTakingItem.$,
              isNew: isNew,
              isFamilyPrice: isFamily,
              isTemporaryFamilyPrice: isFamilyTemporary,
              isNewLowerPrice: isNewLowerPrice,
              isTimeRestrictedOffer: isTimeRestrictedOffer,
              Measurements: measurements,
              PackageMeasurements: packageMeasurements,
              MeasureReferenceText: _this._getMeasureReferenceText(item),
              TechnicalInformation: technicalInfo,
              GoodToKnow: _this._getGoodToKnowList(item),
              CustomerBenefit: _this._getCustomerBenefitList(item),
              ItemFees: _this._getRetailItemFees(item),
              EnergyClass: energyClass,
              RelatedItems: _this._getRelatedItems(item),
              Images: _this._getImages(item),
              ProductInfoPageURL: itemProductInfoPageUrl,
              CareInstructions: _this._getCareInstructionList(item),
              CustomerMaterials: _this._getCustomerMaterialList(item),
              PeopleAndPlanet: _this._getPeopleAndPlanet(item)
            };
            Object.defineProperty(data, 'MeassureInformation', {
              get: function get() {
                _Console.default.warn('RetailItemParser: The property with name "MeassureInformation" is deprecated. Please use "Measurements" instead');

                return measurements;
              }
            });
            Object.defineProperty(data, 'CustomerEnvironments', {
              get: function get() {
                _Console.default.warn('RetailItemParser: The property with name "CustomerEnvironments" is deprecated. Please use "PeopleAndPlanet" instead');

                return _this._getCustomerEnvironmentList(item);
              }
            });

            if (data.ItemType === 'SPR') {
              data.ChildItems = _this._getChildItems(item.RetailItemCommChildList);
            }

            itemsData.push(data);
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return itemsData;
      }

      return [];
    }
    /**
     * Parses encoded as HTML.
     *
     * Note: This was added as FR_fr in some situations sends a single quote as HTML encoded.
     *
     * @param {string} html HTML to parse.
     * @returns {boolean} TRUE if new.
     */

  }, {
    key: "_parseHtml",
    value: function _parseHtml(html) {
      return html.replace(/&#39;/g, "'");
    }
    /**
     * Checks if an item is new.
     *
     * @param {object} item Item to check.
     * @returns {boolean} TRUE if new.
     */

  }, {
    key: "_isNewItem",
    value: function _isNewItem(item) {
      var isNew = false;

      if (item.NewsType && item.NewsType.$) {
        if (item.NewsType.$ === 'ICON' || item.NewsType.$ === 'COMMERCIAL') {
          isNew = true;
        }
      }

      return isNew;
    }
    /**
     * Returns the technical information list.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} Technical information list.
     */

  }, {
    key: "_getTechnicalInformationList",
    value: function _getTechnicalInformationList(data) {
      if (data) {
        if (data.RetailItemTechnicalInformationGroup) {
          var list = data.RetailItemTechnicalInformationGroup.RetailItemTechnicalInformationList;

          if (list && list.RetailItemTechnicalInformation) {
            var array = Array.isArray(list.RetailItemTechnicalInformation) ? list.RetailItemTechnicalInformation : [list.RetailItemTechnicalInformation];
            return array.map(function (item) {
              return {
                RangeNo: item.TechnicalInformationRangeNo.$,
                Number: item.TechnicalInformationNo.$,
                Text: item.TechnicalInformationText.$,
                Value: item.TechnicalInformationValueMetric.$
              };
            });
          }

          return [];
        }
      }

      return null;
    }
    /**
     * Returns the energy class.
     *
     * @param {object[]} items Items to parse.
     * @returns {string|null} Energy class.
     */

  }, {
    key: "_getEnergyClass",
    value: function _getEnergyClass(items) {
      if (items && items.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(items),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;

            if (typeof item.Value === 'string') {
              if (_ServiceSettings.default.retailItemEfficiencyClasses && _ServiceSettings.default.retailItemEfficiencyClasses.includes(item.Number)) {
                return item.Value;
              } else if (ENERGY_CLASSES[item.Value]) {
                return item.Value;
              } else if (process && process.env && process.env.NODE_ENV === 'development' && ENERGY_CLASSES[item.Value.split(' ')[0]]) {
                _Console.default.warn('ArticleService: Potential energy class missed. Number: ' + item.Number + ', Value: ' + item.Value + '');
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return null;
    }
    /**
     * Returns the price object.
     *
     * @param {object} [price] Price object. Returns null if not set.
     * @returns {object|null} Price object.
     */

  }, {
    key: "_getPriceObject",
    value: function _getPriceObject(price) {
      if (!price || !price.Price || price.Price['@nil']) {
        return null;
      }

      return {
        Currency: price.CurrencyCode.$,
        Price: Number(price.Price.$),
        PriceExclTax: price.PriceExclTax ? Number(price.PriceExclTax.$) : null,
        ValidFrom: price.ValidFromDateTime ? price.ValidFromDateTime.$ : null,
        ValidTo: price.ValidToDateTime ? price.ValidToDateTime.$ : null,
        isTemporary: price.ValidFromDateTime && price.ValidToDateTime ? true : false
      };
    }
    /**
     * Returns the article number.
     *
     * @param {string} articleId Article number.
     * @returns {string} Article number.
     */

  }, {
    key: "_getArticleNumber",
    value: function _getArticleNumber(articleId) {
      var articleNumber = String(articleId).replace('S', '');

      if (articleNumber.length === 8) {
        return articleNumber.substr(0, 3) + '.' + articleNumber.substr(3, 3) + '.' + articleNumber.substr(6);
      }

      return articleNumber;
    }
    /**
     * Returns measurements.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} List of measurements.
     */

  }, {
    key: "_getMeasurements",
    value: function _getMeasurements(data) {
      if (data && data.RetailItemCommMeasureList) {
        var list = data.RetailItemCommMeasureList.RetailItemCommMeasure;
        var array = Array.isArray(list) ? list : [list];
        return array.map(function (item) {
          return {
            Type: item.ItemMeasureTypeName ? item.ItemMeasureTypeName.$ : null,
            GlobalType: item.ItemMeasureType ? item.ItemMeasureType.$ : null,
            MetricValue: item.ItemMeasureTextMetric ? item.ItemMeasureTextMetric.$ : null,
            ImperialValue: item.ItemMeasureTextImperial ? item.ItemMeasureTextImperial.$ : null,
            Sort: item.SortNo ? item.SortNo.$ : null
          };
        });
      }

      return [];
    }
    /**
     * Returns package measurements.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} List of package measurements.
     */

  }, {
    key: "_getPackageMeasurements",
    value: function _getPackageMeasurements(data) {
      if (data && data.RetailItemCommPackageMeasureList && data.RetailItemCommPackageMeasureList.RetailItemCommPackageMeasure) {
        var list = data.RetailItemCommPackageMeasureList.RetailItemCommPackageMeasure;
        var array = Array.isArray(list) ? list : [list];
        return array.map(function (item) {
          return {
            ConsumerPackNumber: item.ConsumerPackNumber && item.ConsumerPackNumber.$ !== undefined ? item.ConsumerPackNumber.$ : 1,
            Type: item.PackageMeasureType.$,
            MetricValue: item.PackageMeasureTextMetric.$,
            ImperialValue: item.PackageMeasureTextImperial.$,
            Sort: item.SortNo.$
          };
        });
      }

      return [];
    }
    /**
     * Returns measure reference text.
     *
     * @param {object} data Data to parse.
     * @returns {object} Object with measure reference text.
     */

  }, {
    key: "_getMeasureReferenceText",
    value: function _getMeasureReferenceText(data) {
      var text = {
        Imperial: '',
        Metric: ''
      };

      if (data) {
        if (data.ItemMeasureReferenceTextImperial) {
          text.Imperial = data.ItemMeasureReferenceTextImperial.$;
        }

        if (data.ItemMeasureReferenceTextMetric) {
          text.Metric = data.ItemMeasureReferenceTextMetric.$;
        }
      }

      return text;
    }
    /**
     * Returns list of good to know text.
     *
     * @param {object} data Data to parse.
     * @returns {object[]|null} List of good to know text.
     */

  }, {
    key: "_getGoodToKnowList",
    value: function _getGoodToKnowList(data) {
      if (data && data.RetailItemGoodToKnowList) {
        var list = data.RetailItemGoodToKnowList.RetailItemGoodToKnow;
        var array = Array.isArray(list) ? list : [list];
        return array.map(function (item) {
          return {
            Type: item.GoodToKnowTypeNameEn ? item.GoodToKnowTypeNameEn.$ : null,
            Text: item.GoodToKnowText ? item.GoodToKnowText.$ : null,
            Sort: item.SortNo ? item.SortNo.$ : 0
          };
        });
      }

      return [];
    }
    /**
     * Returns care instructions.
     *
     * @param {object} data Data to parse.
     * @returns {string[]|null} List of care instructions.
     */

  }, {
    key: "_getCareInstructionList",
    value: function _getCareInstructionList(data) {
      if (data && data.RetailItemCareInstructionList) {
        var list = data.RetailItemCareInstructionList.RetailItemCareInstruction;
        var array = Array.isArray(list) ? list : [list];
        var returnTexts = [];

        for (var i = 0, max = array.length; i < max; i++) {
          var texts = array[i].RetailItemCareInstructionTextList && array[i].RetailItemCareInstructionTextList.RetailItemCareInstructionText;
          var textsArray = Array.isArray(texts) ? texts : [texts];
          returnTexts = returnTexts.concat(textsArray.map(function (text) {
            return text.CareInstructionText ? text.CareInstructionText.$ : null;
          }));
        }

        return returnTexts;
      }

      return [];
    }
    /**
     * Returns customer materials.
     *
     * @param {object} data Data to parse.
     * @returns {object[]|null} List of customer materials.
     */

  }, {
    key: "_getCustomerMaterialList",
    value: function _getCustomerMaterialList(data) {
      if (data && data.RetailItemCustomerMaterialList) {
        var list = data.RetailItemCustomerMaterialList.RetailItemCustomerMaterial;
        var materials = Array.isArray(list) ? list : [list];
        var parsed = [];

        var _iterator3 = _createForOfIteratorHelper(materials),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var material = _step3.value;
            var partMaterials = material.RetailItemPartMaterialList && material.RetailItemPartMaterialList.RetailItemPartMaterial;
            var partMaterialsList = Array.isArray(partMaterials) ? partMaterials : [partMaterials];

            var _iterator4 = _createForOfIteratorHelper(partMaterialsList),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var partMaterial = _step4.value;
                parsed.push({
                  TextPart: partMaterial.PartText ? partMaterial.PartText.$ : null,
                  TextType: material.ProductTypeText ? material.ProductTypeText.$ : null,
                  Text: partMaterial.MaterialText ? partMaterial.MaterialText.$ : null
                });
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        return parsed;
      }

      return [];
    }
    /**
     * Returns people and planet.
     *
     * @param {object} data Data to parse.
     * @returns {string[]|null} List of people and planet texts.
     */

  }, {
    key: "_getPeopleAndPlanet",
    value: function _getPeopleAndPlanet(data) {
      var texts = [];

      if (data && data.RetailItemCustomerEnvironmentList) {
        var list = data.RetailItemCustomerEnvironmentList.RetailItemCustomerEnvironment;
        var array = Array.isArray(list) ? list : [list];

        var _iterator5 = _createForOfIteratorHelper(array),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var item = _step5.value;
            var textsList = item.RetailItemEnvironmentTextList && item.RetailItemEnvironmentTextList.RetailItemEnvironmentText;
            var textsArray = Array.isArray(textsList) ? textsList : [textsList];

            var _iterator6 = _createForOfIteratorHelper(textsArray),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var text = _step6.value;

                if (text.EnvironmentText) {
                  texts.push(text.EnvironmentText.$);
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      return texts;
    }
    /**
     * Returns customer environments.
     *
     * @param {object} data Data to parse.
     * @returns {object[]|null} List of customer environments.
     */

  }, {
    key: "_getCustomerEnvironmentList",
    value: function _getCustomerEnvironmentList(data) {
      if (data && data.RetailItemCustomerEnvironmentList) {
        var list = data.RetailItemCustomerEnvironmentList.RetailItemCustomerEnvironment;
        var array = Array.isArray(list) ? list : [list];
        return array.map(function (item) {
          var textsList = item.RetailItemEnvironmentTextList && item.RetailItemEnvironmentTextList.RetailItemEnvironmentText;
          var textsArray = Array.isArray(textsList) ? textsList : [textsList];
          var texts = textsArray.map(function (text) {
            return text.EnvironmentText ? text.EnvironmentText.$ : null;
          });
          return {
            ProductType: item.ProductTypeText ? item.ProductTypeText.$ : null,
            Texts: texts
          };
        });
      }

      return [];
    }
    /**
     * Returns list of customer benefits.
     *
     * @param {object} data Data to parse.
     * @returns {object[]|null} List of customer benefits.
     */

  }, {
    key: "_getCustomerBenefitList",
    value: function _getCustomerBenefitList(data) {
      if (data) {
        if (data.RetailItemCustomerBenefitList) {
          var list = data.RetailItemCustomerBenefitList.RetailItemCustomerBenefit;

          if (Array.isArray(list)) {
            return list.map(this._getCustomerBenefit);
          } else {
            return [this._getCustomerBenefit(list)];
          }
        }

        return [];
      }

      return null;
    }
    /**
     * Returns customer benefit item.
     *
     * @param {object} item Item to parse.
     * @returns {object} Object with customer benefit info.
     */

  }, {
    key: "_getCustomerBenefit",
    value: function _getCustomerBenefit(item) {
      return {
        Text: item.CustomerBenefitText.$,
        Sort: item.SortNo.$
      };
    }
    /**
     * Returns retail item fees.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} Array with retail item fees items.
     */

  }, {
    key: "_getRetailItemFees",
    value: function _getRetailItemFees(data) {
      if (data.RetailItemFeeList) {
        var list = data.RetailItemFeeList.RetailItemFee;
        var array = Array.isArray(list) ? list : [list];
        return array.map(function (item) {
          return {
            Type: item.FeeType.$,
            Amount: item.FeeAmount.$,
            CurrencyCode: item.CurrencyCode.$
          };
        });
      }

      return [];
    }
    /**
     * Returns related retail items data.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} Array of related item.
     */

  }, {
    key: "_getRelatedItems",
    value: function _getRelatedItems(data) {
      if (data.CatalogElementRelationList && data.CatalogElementRelationList.CatalogElementRelation) {
        var relations = data.CatalogElementRelationList.CatalogElementRelation;
        var items = Array.isArray(relations) ? relations : [relations];
        return items.map(function (item) {
          return {
            ID: item.CatalogElementId ? String(item.CatalogElementId.$) : null,
            Name: item.CatalogElementName ? item.CatalogElementName.$ : null,
            Type: item.CatalogElementType ? item.CatalogElementType.$ : null,
            Relation: {
              Type: item.CatalogElementRelationType ? item.CatalogElementRelationType.$ : null,
              Semantic: item.CatalogElementRelationSemantic ? item.CatalogElementRelationSemantic.$ : null
            }
          };
        });
      }

      return [];
    }
    /**
     * Returns image data.
     *
     * @param {object} item Item to parse.
     * @returns {object[]} Image data.
     */

  }, {
    key: "_getImages",
    value: function _getImages(item) {
      var images = {};

      if (item.RetailItemImageList && item.RetailItemImageList.RetailItemImage) {
        var list = Array.isArray(item.RetailItemImageList.RetailItemImage) ? item.RetailItemImageList.RetailItemImage : [item.RetailItemImageList.RetailItemImage];

        var _iterator7 = _createForOfIteratorHelper(list),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _item = _step7.value;
            var size = _item.ImageSize ? _item.ImageSize.$ : 0;
            var typeName = 'Inspirational Product Picture';
            var imageUrl = _item.ImageUrl ? _item.ImageUrl.$ : null;

            if (!images[size]) {
              images[size] = [];
              typeName = 'Main Product Picture';
            }

            images[size].push({
              Size: size,
              Usage: _item.ImageUsage ? _item.ImageUsage.$ : null,
              Url: imageUrl,
              TypeName: typeName,
              Width: _item.ImageWidth ? _item.ImageWidth.$ : 0,
              Height: _item.ImageHeight ? _item.ImageHeight.$ : 0,
              SortNo: _item.SortNo ? _item.SortNo.$ : 0
            });
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }

      return images;
    }
    /**
     * Returns child items.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} Array of child items.
     */

  }, {
    key: "_getChildItems",
    value: function _getChildItems(data) {
      var _this2 = this;

      if (data && data.RetailItemCommChild) {
        var children = Array.isArray(data.RetailItemCommChild) ? data.RetailItemCommChild : [data.RetailItemCommChild];
        return children.map(function (item) {
          return {
            ID: item.ItemNo ? String(item.ItemNo.$) : null,
            GlobalID: item.ItemNoGlobal ? String(item.ItemNoGlobal.$) : null,
            LocalID: item.ItemNo ? String(item.ItemNo.$) : null,
            ItemType: item.ItemType ? String(item.ItemType.$) : null,
            Quantity: item.Quantity ? item.Quantity.$ : null,
            ArticleNumber: item.ItemNo ? _this2._getArticleNumber(item.ItemNo.$) : null,
            ProductName: item.ProductName ? item.ProductName.$ : null,
            ProductTypeName: item.ProductTypeName ? item.ProductTypeName.$ : null,
            Images: _this2._getImages(item)
          };
        });
      }

      return [];
    }
  }]);

  return RetailItemParser;
}();

exports.default = RetailItemParser;